export default __webpack_public_path__ + "static/media/dolcemare5.fa703fac.jpg";